import axios from 'axios';
import {useState} from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import Error from '../../common/Error';


import { useSessionContext } from '../../../contexts/SessionContext';


export default function NamedLocationsEditLookup(props) {
    //console.debug("RTS Break NamedLocationsEditLookupCoords");

    const {userAuthToken, mapBoxKey} = useSessionContext();

    const [hasError] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle] = useState("Validation Error");

    const [lat, setLat] = useState('');
    const [lng, setLng] = useState('');


    function handleSubmit(e) {
        e.preventDefault();

        let returnVal = {
                address:null,
                address2:null,
                city:null,
                region:null,
                zip:null,
                lat:null,
                lng:null
            }

        let query = lng + ',' + lat;
        let accessToken = mapBoxKey;
        let apiURL = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${accessToken}`;

        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
            )
        .then(response => {

            if(response.data){
                if(response.data.features && response.data.features.length > 0){
                    let features = response.data.features[0];


                    if(features.place_type){
                        let placeType = features.place_type[0];

                        if(placeType === 'address'){
                            if(features.place_name){
                                let parts = features.place_name.split(',');

                                returnVal.address = parts[0];
                                returnVal.city = parts[1];

                                let numIdx = parts[2].search(/\d/);
                                returnVal.region = parts[2].substring(1, numIdx).trim();
                                returnVal.zip = parts[2].substring(numIdx);
                            }
                        }
                    }

                    if(features.center){
                        returnVal.lat = features.center[1];
                        returnVal.lng = features.center[0];
                    }

                    props.setSearchDataFx(returnVal);
                }
            }
        })
        .catch(error => {
            setErrorBody("An error has occured.  Please review the console log for details.");
            console.log("RTS UpdateCustomerReel Error", error);
            setShowErrorModal(true);
        });
    }


    if(hasError){
        return(
            <Error />
        );
    };
    
    
    return (
        <>
        <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>{errorBody}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Box>
            <form id="locationLookupFormCoords" onSubmit={handleSubmit}>
                <Typography variant="h6" sx={{mt:2, mb:2}}>Coordinates</Typography>
                <TextField
                    id="tbLng"
                    margin="none"
                    fullWidth
                    label="Latitude"
                    size="small"
                    value={lat}
                    onChange={(e) => {setLat(e.target.value);}}
                />
                <TextField
                    id="tbLng"
                    margin="dense"
                    fullWidth
                    label="Longitude"
                    size="small"
                    value={lng}
                    onChange={(e) => {setLng(e.target.value);}}
                />
                <Box sx={{textAlign:'right', mt:2}}>
                    <Button variant="contained" type="submit" sx={{mr:2}}>Search</Button>
                    <Button variant="contained" type="button" onClick={() => {props.setShowLookupModalFx(false);}}>Cancel</Button>
                </Box>
            </form>
        </Box>
        </>
    );
}